import { useQuery } from '@tanstack/react-query';

import { EventQuery } from '../types';
import { buildQuery } from '../utils';
import { useAuthentication } from './use-authentication';

export const useFetch = (
  config: EventQuery,
  queryName: string,
  endPoint: (query: string) => Promise<any>,
  transform?: (data: any) => any,
) => {
  const query = buildQuery(config);
  const { token } = useAuthentication();

  return useQuery(
    [queryName, query],
    async () => {
      const data = await endPoint(query);
      return transform ? transform(data) : data;
    },
    {
      enabled: !!token,
      retry: (failureCount, error) => {
        // Only retry if the error is NOT 401 (Unauthorized)
        if ((error as any).response?.status === 401) {
          return false;
        }
        return failureCount < 3; // Retry up to 3 times for other errors, here 3 is default value for useQuery failureCount
      },
      staleTime: 5 * 60 * 1000, // Data stays fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // Unused data is kept in cache for 10 minutes
    },
  );
};
